import {FC} from 'react'
import {AdminRoom} from '../../../core/_models'

type Props = {
  room: AdminRoom
}

const FranchiseCell: FC<Props> = ({room}) => <span>{room.franchise?.name ?? '-'}</span>

export {FranchiseCell}
